"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Replace = exports.Dot = exports.Objekt = exports.ClazzFulfilled = exports.ClazzCons = exports.ClazzNull = exports.Quote = exports.Cdr = exports.Car = exports.Cons = exports.Sigma = exports.ApImplicit = exports.Ap = exports.FnImplicit = exports.Fn = exports.PiImplicit = exports.Pi = exports.PatternVar = exports.Var = void 0;
function Var(name) {
    return {
        "@type": "Core",
        "@kind": "Var",
        name,
    };
}
exports.Var = Var;
function PatternVar(name) {
    return {
        "@type": "Core",
        "@kind": "PatternVar",
        name,
    };
}
exports.PatternVar = PatternVar;
function Pi(name, argType, retType) {
    return {
        "@type": "Core",
        "@kind": "Pi",
        name,
        argType,
        retType,
    };
}
exports.Pi = Pi;
function PiImplicit(name, argType, retType) {
    return {
        "@type": "Core",
        "@kind": "PiImplicit",
        name,
        argType,
        retType,
    };
}
exports.PiImplicit = PiImplicit;
function Fn(name, ret) {
    return {
        "@type": "Core",
        "@kind": "Fn",
        name,
        ret,
    };
}
exports.Fn = Fn;
function FnImplicit(name, ret) {
    return {
        "@type": "Core",
        "@kind": "FnImplicit",
        name,
        ret,
    };
}
exports.FnImplicit = FnImplicit;
function Ap(target, arg) {
    return {
        "@type": "Core",
        "@kind": "Ap",
        target,
        arg,
    };
}
exports.Ap = Ap;
function ApImplicit(target, arg) {
    return {
        "@type": "Core",
        "@kind": "ApImplicit",
        target,
        arg,
    };
}
exports.ApImplicit = ApImplicit;
function Sigma(name, carType, cdrType) {
    return {
        "@type": "Core",
        "@kind": "Sigma",
        name,
        carType,
        cdrType,
    };
}
exports.Sigma = Sigma;
function Cons(car, cdr) {
    return {
        "@type": "Core",
        "@kind": "Cons",
        car,
        cdr,
    };
}
exports.Cons = Cons;
function Car(target) {
    return {
        "@type": "Core",
        "@kind": "Car",
        target,
    };
}
exports.Car = Car;
function Cdr(target) {
    return {
        "@type": "Core",
        "@kind": "Cdr",
        target,
    };
}
exports.Cdr = Cdr;
function Quote(data) {
    return {
        "@type": "Core",
        "@kind": "Quote",
        data,
    };
}
exports.Quote = Quote;
function ClazzNull(name) {
    return {
        "@type": "Core",
        "@kind": "ClazzNull",
        name,
    };
}
exports.ClazzNull = ClazzNull;
function ClazzCons(propertyName, localName, propertyType, rest, name) {
    return {
        "@type": "Core",
        "@kind": "ClazzCons",
        propertyName,
        localName,
        propertyType,
        rest,
        name,
    };
}
exports.ClazzCons = ClazzCons;
function ClazzFulfilled(propertyName, propertyType, property, rest, name) {
    return {
        "@type": "Core",
        "@kind": "ClazzFulfilled",
        propertyName,
        propertyType,
        property,
        rest,
        name,
    };
}
exports.ClazzFulfilled = ClazzFulfilled;
function Objekt(properties) {
    return {
        "@type": "Core",
        "@kind": "Objekt",
        properties,
    };
}
exports.Objekt = Objekt;
function Dot(target, name) {
    return {
        "@type": "Core",
        "@kind": "Dot",
        target,
        name,
    };
}
exports.Dot = Dot;
function Replace(target, motive, base) {
    return {
        "@type": "Core",
        "@kind": "Replace",
        target,
        motive,
        base,
    };
}
exports.Replace = Replace;
//# sourceMappingURL=Core.js.map